import React from 'react';

const SPEEDS = [0.25, 0.5, 0.75, 1, 1.5, 2, 4];

interface SpeedMenuProps {
  currentSpeed: number;
  onSelect: (speed: number) => void;
  onClose: () => void;
}

const SpeedMenu: React.FC<SpeedMenuProps> = ({ currentSpeed, onSelect, onClose }) => {
  return (
    <div className="speed-menu dropdown-menu">
      <div className="dropdown-header">Playback Speed</div>
      {SPEEDS.map(s => (
        <button
          key={s}
          className={`dropdown-item ${currentSpeed === s ? 'dropdown-item--active' : ''}`}
          title={s === 1 ? 'Play at normal speed' : `Play the clip at ${s}× speed`}
          onClick={() => { onSelect(s); onClose(); }}
        >
          {currentSpeed === s && <span className="dropdown-check">✓</span>}
          {s}x{s === 1 ? ' (Normal)' : ''}
        </button>
      ))}
    </div>
  );
};

export default SpeedMenu;
